// next
import NextLink from 'next/link';
// layouts
import Layout from '../layouts';
// componentes
import Page from '../components/Page';

// ----------------------------------------------------------------------
// Pagina de manutencao - migrada do MUI para o visual novo (tokens --gps-*).
//
// A ilustracao MUI (MaintenanceIllustration) foi trocada por um bloco
// tipografico simples, mesma decisao das paginas 404/500: o arquivo fonte e
// MUI puro e nao tem substituto no design novo.
// ----------------------------------------------------------------------

Maintenance.getLayout = function getLayout(page) {
  return <Layout variant="logoOnly">{page}</Layout>;
};

// ----------------------------------------------------------------------

export default function Maintenance() {
  return (
    <Page title="Maintenance">
      <div className="flex min-h-full items-center justify-center bg-fundo px-4 py-24">
        <div className="mx-auto max-w-[480px] text-center">
          <span className="text-4xl">🛠️</span>

          <h1 className="mt-3 text-xl font-extrabold tracking-[-0.02em] text-ink">
            Site em manutencao no momento
          </h1>

          <p className="mt-2 text-[12.5px] text-muted-foreground">
            Estamos trabalhando duro nesta pagina!
          </p>

          <NextLink
            href="/"
            className="mt-8 inline-flex h-10 items-center justify-center rounded-lg bg-primary px-5 text-[12.5px] font-bold text-primary-foreground no-underline"
          >
            Ir para Home
          </NextLink>
        </div>
      </div>
    </Page>
  );
}
